import {Modal} from './classes/modal';
import {fromEvent, map, tap} from "rxjs";

const modal = document.querySelector('.modal#order-modal');
if (modal) {
    const modalObj = Modal(modal);
    fromEvent(document.querySelector('form#search-trip'), 'submit')
        .pipe(
            tap(e => {
                e.preventDefault();
            }),
            map(e => {
                const { city, country } = e.target.elements;
                return {
                    city: city?.value ? city?.value : null,
                    country: country?.value
                        ? country?.value !== 'Kraj' ? country?.value : null
                        : null
                };
            })
        )
        .subscribe((data) => {
            modalObj.show();
            modalObj.getInstance().querySelector('select#kraj-docelowy').value = data.country;
            modalObj.getInstance().querySelector('input#miejsce-docelowe').value = data.city;
        })

}
